import { createReducer } from 'utils'
import { fromJS } from 'immutable'

import { constants } from 'common/actions/systems'
import { RESET_ERROR } from 'common/actions/error'

export const initialState = fromJS({
  isSubmitting: false,
  error: null
})

export default createReducer(initialState, {
  [RESET_ERROR]: state => state.set('error', null),

  [constants.UPDATE_SYSTEM_PERIODICITY_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.UPDATE_SYSTEM_PERIODICITY_REQUEST.SUCCESS]: () => initialState,
  [constants.UPDATE_SYSTEM_PERIODICITY_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  },
  [constants.UPDATE_SYSTEM_GLOBAL_PERIODICITY_REQUEST.START]: state =>
    state.set('isSubmitting', true),
  [constants.UPDATE_SYSTEM_GLOBAL_PERIODICITY_REQUEST.SUCCESS]: () => initialState,
  [constants.UPDATE_SYSTEM_GLOBAL_PERIODICITY_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  }
})
